<template>
    <div class="slick">
        <SlickList
          :useDragHandle="true"
          appendTo=".slick"
          @sort-end="onSelected"
          lockAxis="y"
          v-model="lists"
        >
          <SlickItem class="slick__item" v-for="(item, index) in lists" :key="index" :index="index">
            <div class="col-name">
              <span class="name">{{ changeLanguage(item) }}</span>
            </div>
            <div class="col-action handle" v-handle>
              <i class="fas fa-bars"></i>
            </div>
          </SlickItem>
        </SlickList>
    </div>
</template>

<script>
import _move from "lodash-move"
import { SlickList, SlickItem, HandleDirective } from "vue-slicksort"
export default {
    components: {
      SlickList,
      SlickItem,
    },
    directives: { handle: HandleDirective },
    props: {
      objUserSetting: {
        type: Object,
        default: function() {
          return []
        }
      }
    },
    data() {
      return {
        lists: this.objUserSetting.assets
      }
    },
    methods: {
      changeLanguage(value) {
        if (this.objUserSetting.language === "TH") {
          switch (value) {
            case "fund":
              return "กองทุน"
            case "stock":
              return "หุ้น"
            case "indices":
              return "ดัชนี"
            case "gold":
              return "ทองคำ"
            case "crypto":
              return "คริปโต"
            case "lotto":
              return "สลากออมสิน"
            case "savings":
              return "เงินออม"
            default:
              return value
          }
        } else {
          return value
        }
      },
      onSelected(e) {
        this.$emit("callback-func", { val: _move(this.lists, e.oldIndex, e.newIndex), type: "assets" })
      }
    }
}
</script>

<style lang="scss" scoped>
    .slick {
      @include finCol(12, 12, 0px, middle, true, true);
      @include responsive(tablet) {
        @include finCol(6, 12, 0px, middle, true, true);
      }
      @include responsive(desktop) {
        @include finCol(8, 12, 0px, middle, true, true);
      }
      &__item {
        @include responsive(tablet) {
          font-size: 18px;
        }
        background: var(--color-surface);

        margin: 8px 0;
        padding: 0 16px;
        width: 100%;
        display: flex;
        justify-content: center;
        border: 1px solid var(--color-outline);
        height: 48px;
        border-radius: 4px;
        .col-name,
        .col-action {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .name {
            height: 22px;
          }
        }
        .col-name {
          width: 80%;
          .name {
            @include responsive(tablet) {
              font-size: 18px;
            }
            @extend %font-size-s;
            font-weight: bold;
            color: var(--color-header-text);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-transform: capitalize;
          }
        }
        .col-action {
          width: 20%;
          i {
            text-align: right;
            font-size: 16px;
            color: $color-light-grey-2;
          }
        }
      }
    }
</style>
